var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhoWeAre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.26,101.67a4.49,4.49,0,0,0-4.5,4.5V114h9v-7.83A4.49,4.49,0,0,0,215.26,101.67Zm0,6.58a1.42,1.42,0,1,1,1.42-1.42A1.42,1.42,0,0,1,215.26,108.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.26,101.67a4.49,4.49,0,0,0-4.5,4.5V114h9v-7.83A4.49,4.49,0,0,0,400.26,101.67Zm0,6.58a1.42,1.42,0,1,1,1.42-1.42A1.42,1.42,0,0,1,400.26,108.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.79,
    y: 111,
    width: 235.93,
    height: 135.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.29,
    y: 117.5,
    width: 222.93,
    height: 122.31,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.43,
    y: 241.72,
    width: 244.67,
    height: 10.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,139H223v70h169.5V139Zm94.63,34.5H328.76V163h30.88Zm0,11.5H328.76V174.5h30.88Zm0,11.5H328.76V186h30.88ZM235.51,186H264v10.5h-28.5Zm0-11.5H264V185h-28.5Zm0-11.5H264v10.5h-28.5Zm0-11.5H264V162h-28.5Zm92.25,22H296.89V163h30.87Zm0,11.5H296.89V174.5h30.87ZM265,174.5h30.88V185H265Zm30.88-1H265V163h30.88ZM265,186h30.88v10.5H265Zm31.88,0h30.87v10.5H296.89Zm30.87-24H265V151.5h62.75ZM224,140h40v10.5H224Zm0,11.5h10.5V162H224Zm0,11.5h10.5v10.5H224Zm0,11.5h10.5V185H224Zm0,11.5h10.5v10.5H224Zm10.5,22H224V197.5h10.5Zm29.5,0h-28.5V197.5H264Zm31.88,0H265V197.5h30.88Zm31.87,0H296.89V197.5h30.87Zm31.88,0H328.76V197.5h30.88Zm31.87,0H360.64V197.5h30.87Zm0-11.5H360.64V186h30.87Zm0-11.5H360.64V174.5h30.87Zm0-11.5H360.64V163h30.87Zm0-11.5H328.76V151.5h62.75Zm-62.75-11.5H265V140h126.5v10.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.49,
    y: 193.84,
    width: 22.5,
    height: 188.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 193.84,
    width: 63.16,
    height: 188.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 200.27,
    width: 50.29,
    height: 50.29,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,229.86H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,229.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,235.39H105.51a1.39,1.39,0,0,1-1.39-1.39h0a1.38,1.38,0,0,1,1.39-1.38h27.21A1.38,1.38,0,0,1,134.1,234h0A1.38,1.38,0,0,1,132.72,235.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,240.91H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,240.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 219.66 113.75 219.66 110.93 216.83 110.93 210.79 113.75 207.96 124.47 207.96 127.3 210.79 127.3 216.83 124.47 219.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 255.38,
    width: 50.29,
    height: 50.29,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,285H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,285Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,290.49H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,290.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,296H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,296Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 274.76 113.75 274.76 110.93 271.93 110.93 265.9 113.75 263.07 124.47 263.07 127.3 265.9 127.3 271.93 124.47 274.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 310.48,
    width: 50.29,
    height: 50.29,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,340.07H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,340.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,345.6H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.39,1.39,0,0,1,1.39-1.39h27.21a1.38,1.38,0,0,1,1.38,1.39h0A1.38,1.38,0,0,1,132.72,345.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,351.12H105.51a1.38,1.38,0,0,1-1.39-1.38h0a1.38,1.38,0,0,1,1.39-1.38h27.21a1.38,1.38,0,0,1,1.38,1.38h0A1.38,1.38,0,0,1,132.72,351.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 329.87 113.75 329.87 110.93 327.04 110.93 321 113.75 318.17 124.47 318.17 127.3 321 127.3 327.04 124.47 329.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-10",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.6,411.82l-25.2-9.28-25.48,9.29a1.35,1.35,0,0,1-1.81-1.27h0a1.34,1.34,0,0,1,.78-1.22L93.4,397l26.24,12.3a1.35,1.35,0,0,1,.78,1.22h0A1.35,1.35,0,0,1,118.6,411.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.6,411.82l-25.2-9.28-25.48,9.29a1.35,1.35,0,0,1-1.81-1.27h0a1.34,1.34,0,0,1,.78-1.22L93.4,397l26.24,12.3a1.35,1.35,0,0,1,.78,1.22h0A1.35,1.35,0,0,1,118.6,411.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.46 404.7 93.4 402.54 99.06 404.63 99.06 399.69 93.4 397.04 87.46 399.79 87.46 404.7",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.26,412h0A2.25,2.25,0,0,1,91,410l-.71-7.47v-62H96.2v62L95.49,410A2.24,2.24,0,0,1,93.26,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.26,412h0A2.25,2.25,0,0,1,91,410l-.71-7.47v-62H96.2v62L95.49,410A2.24,2.24,0,0,1,93.26,412Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.32,
    y: 340.52,
    width: 5.88,
    height: 7.22,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08,276.63a2.48,2.48,0,0,1,2.24,1.29,86.84,86.84,0,0,1,10.88,60,2.19,2.19,0,0,1-2.09,1.95c-1.63.12-30.65,0-31.7,0a2.92,2.92,0,0,1-2.95-3.4,81.07,81.07,0,0,0-10.33-55.79,2.69,2.69,0,0,1,2.44-4C49.41,276.61,78.23,276.66,80.08,276.63Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08,276.63a2.48,2.48,0,0,1,2.24,1.29,86.84,86.84,0,0,1,10.88,60,2.19,2.19,0,0,1-2.09,1.95c-1.63.12-30.65,0-31.7,0a2.92,2.92,0,0,1-2.95-3.4,81.07,81.07,0,0,0-10.33-55.79,2.69,2.69,0,0,1,2.44-4C49.41,276.61,78.23,276.66,80.08,276.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.46,336.45a81.07,81.07,0,0,0-10.33-55.79c-1.8-3,2.89-5.73,4.69-2.74a86.9,86.9,0,0,1,10.88,60c-.62,3.43-5.86,2-5.24-1.44Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.46,336.45a81.07,81.07,0,0,0-10.33-55.79c-1.8-3,2.89-5.73,4.69-2.74a86.9,86.9,0,0,1,10.88,60c-.62,3.43-5.86,2-5.24-1.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147,334.88a91.44,91.44,0,0,0-20.34-2.8c-7.07-.18-33.5,0-39.78,0a91.44,91.44,0,0,0-22.7,2.83c-4.66,1.19-3.23,7.91,1,8,.37,0,80.3,0,80.59,0C150.1,343.07,151.71,336.09,147,334.88Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,334.88a91.44,91.44,0,0,0-20.34-2.8c-7.07-.18-33.5,0-39.78,0a91.44,91.44,0,0,0-22.7,2.83c-4.66,1.19-3.23,7.91,1,8,.37,0,80.3,0,80.59,0C150.1,343.07,151.71,336.09,147,334.88Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29,342.73a83.25,83.25,0,0,1,41.07,0c5.08,1.29,7.25-6.56,2.17-7.85a92.3,92.3,0,0,0-45.4,0c-5.08,1.29-2.93,9.14,2.16,7.85Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.29,342.73a83.25,83.25,0,0,1,41.07,0c5.08,1.29,7.25-6.56,2.17-7.85a92.3,92.3,0,0,0-45.4,0c-5.08,1.29-2.93,9.14,2.16,7.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.86,292.38l9.19-.39,2.75-1.76a2.77,2.77,0,0,1,2.19-.36l2,.49a2.81,2.81,0,0,0,2.81-.89h0a2.81,2.81,0,0,0-.79-4.3l-3-1.62a2.79,2.79,0,0,0-3,.21l-4.84,3.58-7.29-.51Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.91,256.76l-3.18,28,17.89,1.28-.79,6.43s-18.09,3.16-24.72,1.35,2.2-32.11,2.2-32.11Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.91,256.76l-3.18,28,17.89,1.28-.79,6.43s-18.09,3.16-24.72,1.35,2.2-32.11,2.2-32.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,291.3c-4.67-2.43,1.6-25.74,3.81-33.42l-6.67,3.85s-8.83,30.3-2.2,32.11c4.08,1.11,12.48.35,18.35-.41C133.46,293.43,127.61,293.09,124.17,291.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08,311.48A157.18,157.18,0,0,1,74,313.74s3.08-35.85,14-55.47A14,14,0,0,1,96,251.74c7.84-2.44,20.45-4.63,33.87,5C129.91,256.76,123.12,269.42,114.08,311.48Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08,311.48A157.18,157.18,0,0,1,74,313.74s3.08-35.85,14-55.47A14,14,0,0,1,96,251.74c7.84-2.44,20.45-4.63,33.87,5C129.91,256.76,123.12,269.42,114.08,311.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,265.69a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,120.6,265.69Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,276.7a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,116.8,276.7Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.27,
    cy: 291.3,
    r: 1.08,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.51,303.45a1.08,1.08,0,1,1-1.08-1.07A1.08,1.08,0,0,1,110.51,303.45Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.93,279.55h0l-13.58,3.06-10.7-2.94-4.22-12.06-.91-6.78h-3s-2.87,21.6,6.93,30.47c6.11,5.53,16.09,1.93,22.73-1.57Q120.63,284.09,121.93,279.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.72 376.68 126.01 397.19 131.86 399.46 140.28 378.83 130.72 376.68",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.52,398.11l-5.31-2.84a.57.57,0,0,0-.69.13l-3.79,4.39a.92.92,0,0,0,.08,1.31.83.83,0,0,0,.16.12c2.23,1.15,4.26,2.09,7,3.57,3.25,1.75,2.21,1.69,6,3.8,2.28,1.27,4.11-1.12,3.2-1.77-4.15-3-4.71-5-5.57-7.54A2.3,2.3,0,0,0,131.52,398.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,313.06,112,311.48s47.71,7.46,47,20.8S139,387.68,139,387.68l-11.38-3.16s8.67-42.29,14.32-49.3c0,0-35.63-4.18-44.55-6.55C92.44,327.36,80.61,329.57,83.33,313.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.07,334.64a25.51,25.51,0,0,0-2.19-11.51c-2.65-6-24.49-9.59-34.94-11l-16.61.91c-2.72,16.51,9.11,14.3,14,15.61C104.23,330.5,127,333.41,137.07,334.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.21 382.33 110.46 403.36 116.79 403.66 121 382.63 111.21 382.33",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.34,401.75l-6.14.13a.55.55,0,0,0-.54.46l-1.18,5.78a1,1,0,0,0,.73,1.13l.2,0c2.56-.09,4.82-.27,8-.33,3.76-.07,2.81.4,7.23.38,2.66,0,3.09-3,2-3.17-5.17-.55-6.69-2.1-8.71-3.91A2.29,2.29,0,0,0,116.34,401.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,313.06s38.44,1.36,40.71,13.12-10.63,64.44-10.63,64.44H109.56s1.35-47.26,5.2-57.21c0,0-31.66,5-40-2.21-6-5.13,1.13-18.14,1.13-18.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.66 382.03 140.99 386.02 138.37 391.53 125.31 388.29 126.66 382.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.66 382.03 140.99 386.02 138.37 391.53 125.31 388.29 126.66 382.03",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,275.6l11.45-3.77,7.33,3.28a2.31,2.31,0,0,1,1.34,1.69l.77,4.17a2.31,2.31,0,0,1-2.27,2.74h0a2.35,2.35,0,0,1-1.48-.53l-6.44-5.32-10,4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.42 387.68 122.9 388.36 121.54 394.13 108.42 393.45 108.42 387.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.42 387.68 122.9 388.36 121.54 394.13 108.42 393.45 108.42 387.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.26,256.76c2.23-3.34,5.78-6.83,14.77,22.61L132,272.74l.79,7.35s-22,11.79-30.83,10.14S84.13,265.94,90.26,256.76Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.26,256.76c2.23-3.34,5.78-6.83,14.77,22.61L132,272.74l.79,7.35s-22,11.79-30.83,10.14S84.13,265.94,90.26,256.76Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45,246.51l-5.11,4.79s2,6.21,7.09,6.21,2-7.86,2-7.86Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,261.11l2.48-1.3,1.05-1.58-.44-4.9a34.53,34.53,0,0,0-13.14-3.6l-.19,2.28,2.77,8,3.23,1.07Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.44,249.65l-4-3.14-.68.63c-.39,2.34-.84,7.2,1.75,9.11a3.21,3.21,0,0,0,2.9.6C124.53,255,122.44,249.65,122.44,249.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,261.73l3.84,2c2.7-3.21,2-7.71,1.41-10.06-.45-.24-.9-.47-1.35-.68.51,3.55.1,7.45-4.13,7.57-6.63.2-7.62-8.28-7.77-10.82l-1.43-.09c-2.1,9.39,3.78,14.08,3.78,14.08Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,261.73l3.84,2c2.7-3.21,2-7.71,1.41-10.06-.45-.24-.9-.47-1.35-.68.51,3.55.1,7.45-4.13,7.57-6.63.2-7.62-8.28-7.77-10.82l-1.43-.09c-2.1,9.39,3.78,14.08,3.78,14.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.13,234.63c3.66,2.37,2.58,8.31-1.24,10.75C133.81,238.58,136.13,234.63,136.13,234.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.13,234.63c3.66,2.37,2.58,8.31-1.24,10.75C133.81,238.58,136.13,234.63,136.13,234.63Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,238.54c-1.37,6.26-2.5,9.84-.33,14a8.34,8.34,0,0,0,11.21,3.64,8.42,8.42,0,0,0,3.55-3.47c2.88-5.09,4.64-14.47-.61-18.83a8.42,8.42,0,0,0-13.82,4.68Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71,244.38c3.35,1.72,5.5-4.15,5-7,4.35,3,14.13,2.54,17-1.43,3.13-4.35-1.57-8-5.82-9.35a2.08,2.08,0,0,0-2.58,1.65.89.89,0,0,1-.31.49,16.94,16.94,0,0,0-2.91-2,3.81,3.81,0,0,0-4.43.78c-.5.45-1.7.54-4.12-.27-5-1.7-5.87,3.76-3.43,4.82-2.21,1.35-5.86,5.06-3.89,8.32s3.66,7.57,2.55,8.28C116.82,249.08,118.63,248,118.71,244.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58,243a5.75,5.75,0,0,0,1.59,3.84c1.31,1.33,2.82.33,3.16-1.44.3-1.6,0-4.21-1.68-4.87S115.57,241.21,115.58,243Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,243.23c-.14.5,0,1,.34,1.07s.7-.22.85-.72,0-1-.35-1.06S128.23,242.73,128.09,243.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,245c-.14.5,0,1,.34,1.06s.7-.22.85-.72,0-1-.35-1.06S133.83,244.53,133.68,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.83,244.71a19.71,19.71,0,0,0,1.14,5,3,3,0,0,1-2.5-.29Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.89,240.85a.35.35,0,0,1-.14-.06.31.31,0,0,1,0-.43h0a3,3,0,0,1,2.74-.5.3.3,0,0,1,.17.39h0a.3.3,0,0,1-.39.17h0a2.34,2.34,0,0,0-2.13.38A.27.27,0,0,1,126.89,240.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63,243.87a.31.31,0,0,1-.17-.23,2.54,2.54,0,0,0-1.26-1.86.31.31,0,0,1-.08-.43.3.3,0,0,1,.34-.12h0a3.11,3.11,0,0,1,1.59,2.31.3.3,0,0,1-.24.35h0A.37.37,0,0,1,136.63,243.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,251.12a5.12,5.12,0,0,0,.85.17.17.17,0,0,0,.2-.13h0a.17.17,0,0,0-.16-.19,4.7,4.7,0,0,1-3.53-2.28.17.17,0,0,0-.23-.08.16.16,0,0,0-.08.23A4.78,4.78,0,0,0,127.65,251.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,232.27A4.06,4.06,0,0,1,115,229.4a.69.69,0,0,0-1.28-.08C112.87,231.13,112.48,233.63,117.94,232.27Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,239.92h-2.87a5,5,0,0,0-4.89,4.49l-2.49,28a4,4,0,0,0,4.09,4.49h2.87Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,239.92h-2.87a5,5,0,0,0-4.89,4.49l-2.49,28a4,4,0,0,0,4.09,4.49h2.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.78,276.92H156a4,4,0,0,1-4.09-4.49l2.49-28a5,5,0,0,1,4.89-4.49h46.78a4,4,0,0,1,4.09,4.49l-2.49,28A5,5,0,0,1,202.78,276.92Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.78,276.92H156a4,4,0,0,1-4.09-4.49l2.49-28a5,5,0,0,1,4.89-4.49h46.78a4,4,0,0,1,4.09,4.49l-2.49,28A5,5,0,0,1,202.78,276.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.86,255.71a2.61,2.61,0,0,1,.1-.69,3.47,3.47,0,0,0-.92-.14,3.54,3.54,0,1,0,3.54,3.54A2.71,2.71,0,0,1,181.86,255.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,290.35h3.6l-1.42-16.28a1.8,1.8,0,0,0-1.79-1.64h0a1.78,1.78,0,0,0-1.78,1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,290.35h3.6l-1.42-16.28a1.8,1.8,0,0,0-1.79-1.64h0a1.78,1.78,0,0,0-1.78,1.95Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.27,295.08a9.45,9.45,0,1,0-18.89,0Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.27,295.08a9.45,9.45,0,1,0-18.89,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,295.08H153.16a1.79,1.79,0,0,1-1.78-1.79h0a1.78,1.78,0,0,1,1.78-1.78h14.92a1.78,1.78,0,0,1,1.78,1.78h0A1.79,1.79,0,0,1,168.08,295.08Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,295.08H153.16a1.79,1.79,0,0,1-1.78-1.79h0a1.78,1.78,0,0,1,1.78-1.78h14.92a1.78,1.78,0,0,1,1.78,1.78h0A1.79,1.79,0,0,1,168.08,295.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.08,295.08H139.17a1.78,1.78,0,0,1-1.78-1.79h0a1.78,1.78,0,0,1,1.78-1.78h14.91a1.79,1.79,0,0,1,1.79,1.78h0A1.79,1.79,0,0,1,154.08,295.08Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.08,295.08H139.17a1.78,1.78,0,0,1-1.78-1.79h0a1.78,1.78,0,0,1,1.78-1.78h14.91a1.79,1.79,0,0,1,1.79,1.78h0A1.79,1.79,0,0,1,154.08,295.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.91,276.85a2.5,2.5,0,0,0-2.25,1.29,86.9,86.9,0,0,0-10.88,60,2.2,2.2,0,0,0,2.09,1.95c1.63.11,30.65,0,31.7,0a2.93,2.93,0,0,0,2.95-3.4,81.12,81.12,0,0,1,10.33-55.79,2.69,2.69,0,0,0-2.44-4C309.57,276.83,280.76,276.88,278.91,276.85Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,276.85a2.5,2.5,0,0,0-2.25,1.29,86.9,86.9,0,0,0-10.88,60,2.2,2.2,0,0,0,2.09,1.95c1.63.11,30.65,0,31.7,0a2.93,2.93,0,0,0,2.95-3.4,81.12,81.12,0,0,1,10.33-55.79,2.69,2.69,0,0,0-2.44-4C309.57,276.83,280.76,276.88,278.91,276.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.52,336.67a81.12,81.12,0,0,1,10.33-55.79c1.81-3-2.89-5.73-4.69-2.74a86.89,86.89,0,0,0-10.87,60c.62,3.43,5.85,2,5.23-1.44Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.52,336.67a81.12,81.12,0,0,1,10.33-55.79c1.81-3-2.89-5.73-4.69-2.74a86.89,86.89,0,0,0-10.87,60c.62,3.43,5.85,2,5.23-1.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,412l-25.2-9.28-25.48,9.29a1.36,1.36,0,0,1-1.82-1.27h0a1.34,1.34,0,0,1,.79-1.22l26.51-12.3,26.24,12.29a1.36,1.36,0,0,1,.77,1.22h0A1.35,1.35,0,0,1,284.73,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,412l-25.2-9.28-25.48,9.29a1.36,1.36,0,0,1-1.82-1.27h0a1.34,1.34,0,0,1,.79-1.22l26.51-12.3,26.24,12.29a1.36,1.36,0,0,1,.77,1.22h0A1.35,1.35,0,0,1,284.73,412Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.59 404.92 259.53 402.76 265.19 404.84 265.19 399.91 259.53 397.25 253.59 400.01 253.59 404.92",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39,412.25h0a2.24,2.24,0,0,1-2.23-2l-.71-7.47v-62h5.88v62l-.71,7.47A2.24,2.24,0,0,1,259.39,412.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39,412.25h0a2.24,2.24,0,0,1-2.23-2l-.71-7.47v-62h5.88v62l-.71,7.47A2.24,2.24,0,0,1,259.39,412.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 340.74,
    width: 5.88,
    height: 7.22,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.94,335.09a92.54,92.54,0,0,1,20.34-2.8c7.06-.17,33.5,0,39.78,0a92,92,0,0,1,22.7,2.83c4.66,1.19,3.22,7.92-1,8-.37,0-80.29,0-80.58,0C209.78,343.28,208.18,336.31,212.94,335.09Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.94,335.09a92.54,92.54,0,0,1,20.34-2.8c7.06-.17,33.5,0,39.78,0a92,92,0,0,1,22.7,2.83c4.66,1.19,3.22,7.92-1,8-.37,0-80.29,0-80.58,0C209.78,343.28,208.18,336.31,212.94,335.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,342.94a83.52,83.52,0,0,0-41.08,0c-5.07,1.3-7.24-6.55-2.16-7.85a92.3,92.3,0,0,1,45.4,0c5.07,1.3,2.92,9.15-2.16,7.85Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.6,342.94a83.52,83.52,0,0,0-41.08,0c-5.07,1.3-7.24-6.55-2.16-7.85a92.3,92.3,0,0,1,45.4,0c5.07,1.3,2.92,9.15-2.16,7.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.84,243.52s-4.92-.48-3.39-7.79,1.4-14.25,12.26-13.46c0,0,8.6-2.15,11,5.93s6,13.81.28,16.19c-7.2,3-9-3.64-9-3.64l-10.53,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,254.22C247,253.33,250,275,244.41,279c-3.09,2.14-18.63-3.61-18.63-3.61l-2.19-7a1.26,1.26,0,0,0-.73-.8l-3.24-1.29a1.26,1.26,0,0,0-1.66,1.47l1.17,5.17a1.25,1.25,0,0,0,.32.6l4.51,4.79s18.53,9,23,7.49c5.24-1.73,7.18-11.27,8.48-16.95C256.46,264.57,258,254.9,253.23,254.22Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.99 384.07 247.88 398.68 242.56 398.82 238.73 384.72 245.99 384.07",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.49,398h6.07a.58.58,0,0,1,.55.44l1.24,5.68a.92.92,0,0,1-.7,1.11.69.69,0,0,1-.2,0c-2.51,0-4.74-.2-7.87-.2-3.69,0-2.76.44-7.1.49-2.61,0-3.08-2.95-2-3.09,5.08-.63,6.52-2.16,8.48-4A2.19,2.19,0,0,1,242.49,398Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.95 392.9 238.73 384.72 245.99 384.07 247.08 392.51 240.95 392.9",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3,296.36h-8.59a47.68,47.68,0,0,0-2.71,12c-.45,6.1,11.3,1.58,11.3,1.58l1-8.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.59 363.83 203.93 380.34 199.18 378.98 203.03 361.57 209.59 363.83",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,377.71l5.84,1.77a.56.56,0,0,1,.42.56l-.22,5.8a.93.93,0,0,1-1,.91.63.63,0,0,1-.19,0c-2.42-.68-4.55-1.37-7.58-2.16-3.57-.93-2.78-.27-7-1.31-2.54-.62-2.25-3.62-1.14-3.48,5.07.66,6.87-.69,9.22-1.95A2.27,2.27,0,0,1,199.27,377.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.5 372.83 200.86 371.38 203.03 361.57 209.59 363.83 206.5 372.83",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.42,295.58s8.74,14.62,7.23,26.83-12.8,18.67-56.21-2.13c0,0-8.91,9.22-23.68,48.71l-7.54-2.26s8.52-45.65,16.13-58.64,41.45,2.26,44-.3c2.28-2.28.3-11.3.3-11.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.6 368.24 209.02 371.29 199.98 368.24 199.98 364.74 210.6 368.24",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.94,256.5l-30.76-2.3a3,3,0,0,0-3.23,3.29,36.32,36.32,0,0,1,.52,5.16c-.27,3.26-2,8.14-1.44,10.37.47,1.78,2.34,3.8,3.08,5.81,1.61,4.35,1.88,18.44,1.88,18.44,9.94,1.61,27.63-.78,27.63-.78-4-14.31,2-31,3.79-37.94A1.65,1.65,0,0,0,284.94,256.5Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.94,256.5l-30.76-2.3a3,3,0,0,0-3.23,3.29,36.32,36.32,0,0,1,.52,5.16c-.27,3.26-2,8.14-1.44,10.37.47,1.78,2.34,3.8,3.08,5.81,1.61,4.35,1.88,18.44,1.88,18.44,9.94,1.61,27.63-.78,27.63-.78-4-14.31,2-31,3.79-37.94A1.65,1.65,0,0,0,284.94,256.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.36,273.4l-10.63,10.88-15.15,3.05-.1,0c.14,1.67.24,3.35.32,4.83,4.19,0,17.88-.29,21.83-3.73a22.64,22.64,0,0,0,4.81-6.66,69.49,69.49,0,0,1,.95-7.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.48,324.38l-2.37-1.84s-8.37,4.53-4.21,17.43h0a151.94,151.94,0,0,1,7.39-13.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.74,332.29c-7.89-1.89-18.1-5.68-31.3-12,0,0-10.19.14-10.87,7.71s17.19,60,17.19,60l8.25-.71s-4.86-52.24-6-54.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.44,320.28a17.11,17.11,0,0,0-3.5.5,73.42,73.42,0,0,0,18.42,11.51h16.38C255.85,330.4,245.64,326.61,232.44,320.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248 385.88 248.22 389.27 238.61 390.02 237.25 386.8 248 385.88",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.42,242.18l-6.71,6.59c1.12,5.42-2.85,5.93-2.85,5.93s.32,1.91,5.18,1.65a29.82,29.82,0,0,0,6.46-.78C269.57,253.23,270,246.1,270.42,242.18Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,251.83a7.23,7.23,0,0,0-.06-3.06l6-5.88.58.68S269.08,251.07,263.77,251.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,233.45c.49,6.46.84,9.19-1.94,12.92-4.19,5.63-12.23,4.82-14.65-1.37-2.17-5.57-2.61-15.2,3.31-18.62A8.85,8.85,0,0,1,271,233.45Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79,240a14.09,14.09,0,0,1-1.4,3.6,2.28,2.28,0,0,0,1.91.09Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.68,235.57a.26.26,0,0,0,.11-.07.25.25,0,0,0,0-.36h0a3,3,0,0,0-2.69-.66.25.25,0,0,0,.14.49,2.52,2.52,0,0,1,2.22.57A.25.25,0,0,0,262.68,235.57Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,236.46a.26.26,0,0,0,.11-.07,2.52,2.52,0,0,1,2.1-.88.28.28,0,0,0,.3-.21h0a.27.27,0,0,0-.23-.29,3,3,0,0,0-2.56,1.05.25.25,0,0,0,0,.36.26.26,0,0,0,.28.05Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,238.61c.08.52-.14,1-.49,1s-.67-.33-.74-.86.15-1,.49-1S261.28,238.09,261.35,238.61Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,239.43c.08.52-.14,1-.48,1s-.67-.34-.75-.86.15-1,.49-1S255.39,238.9,255.45,239.43Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,238.58l-1.3-.19S254.34,239.28,254.86,238.58Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,237.76l-1.3-.18S260.24,238.46,260.76,237.76Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.77,243.9a3.68,3.68,0,0,0,.26-.57.12.12,0,0,0-.06-.16h0a.12.12,0,0,0-.16.08,3.42,3.42,0,0,1-2.22,2.12.13.13,0,0,0-.1.15.12.12,0,0,0,.15.09A3.51,3.51,0,0,0,261.77,243.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,224c-4.15-1-8.45,1.14-8.45,1.14s-4.8,4.27-3.7,8.4a5,5,0,0,1,1.69-.81,6.18,6.18,0,0,1,1.22-4.39,9.18,9.18,0,0,0,.16,4.1,13.93,13.93,0,0,1,5.93.7s.83-1.71,0-5.42a13,13,0,0,1,1.66,6.33c.05,3.84,5,4.77,5,4.77s3.09-.33,3.06-4.47S270.15,225.07,266,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.17,223.79s-2-4.86-5.87-3.67S261.23,221.3,264.17,223.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.2,238.31a4.72,4.72,0,0,1-1.88,3.09c-1.35,1-2.59-.1-2.7-1.67-.09-1.41.5-3.62,2.09-4a2.14,2.14,0,0,1,2.49,2.55Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,256.36c-3.06-1-7.25,10.67-9,14.31-.72,1.51-1.88,4.89-2.76,7.56a7.3,7.3,0,0,1-4.93,4.79l-16.39,4.65-6.66-2a1.71,1.71,0,0,0-1.47.23l-3.35,2.28a1.82,1.82,0,0,0-.79,1.51h0a1.78,1.78,0,0,0,1.9,1.81l9.9-.78s16,.93,23-3S290.64,258.18,285.33,256.36Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,291.54h-56.8a1.55,1.55,0,1,0,0,3.1h56.8a1.55,1.55,0,1,0,0-3.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,291.54h-56.8a1.55,1.55,0,1,0,0,3.1h56.8a1.55,1.55,0,1,0,0-3.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,293.69H236a.73.73,0,0,0,.69-1L226.07,262.3a2.08,2.08,0,0,0-2-1.4H204.68a.74.74,0,0,0-.69,1l10.65,30.42A2.08,2.08,0,0,0,216.61,293.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,293.69H236a.73.73,0,0,0,.69-1L226.07,262.3a2.08,2.08,0,0,0-2-1.4H204.68a.74.74,0,0,0-.69,1l10.65,30.42A2.08,2.08,0,0,0,216.61,293.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,293.69h19.42a.73.73,0,0,0,.69-1L225.14,262.3a2.1,2.1,0,0,0-2-1.4H203.75a.74.74,0,0,0-.7,1L213.7,292.3A2.09,2.09,0,0,0,215.67,293.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.2,
    cy: 277.3,
    rx: 1.31,
    ry: 2.19,
    transform: "translate(-78.32 86.44) rotate(-18.99)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.52,294.64a1.55,1.55,0,0,1,0-3.1h34a1.55,1.55,0,1,1,0,3.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.66,412h0a2.05,2.05,0,0,0,2-2.16l-5.56-108.51h-5.88l7.36,108.76A2,2,0,0,0,407.66,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.66,412h0a2.05,2.05,0,0,0,2-2.16l-5.56-108.51h-5.88l7.36,108.76A2,2,0,0,0,407.66,412Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.14 301.37 398.26 301.37 398.75 308.6 404.51 308.6 404.14 301.37",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,412h0a2.05,2.05,0,0,1-2-2.16L329,301.37h5.88l-7.35,108.76A2.05,2.05,0,0,1,325.47,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,412h0a2.05,2.05,0,0,1-2-2.16L329,301.37h5.88l-7.35,108.76A2.05,2.05,0,0,1,325.47,412Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.62 308.6 334.38 308.6 334.87 301.37 328.99 301.37 328.62 308.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,412h0a2.05,2.05,0,0,0,2-2.16L191.1,301.37h-5.88l7.35,108.76A2.05,2.05,0,0,0,194.62,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,412h0a2.05,2.05,0,0,0,2-2.16L191.1,301.37h-5.88l7.35,108.76A2.05,2.05,0,0,0,194.62,412Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.1 301.37 185.22 301.37 185.71 308.6 191.47 308.6 191.1 301.37",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.43,412h0a2.05,2.05,0,0,1-2-2.16L116,301.37h5.88l-7.36,108.76A2,2,0,0,1,112.43,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.43,412h0a2.05,2.05,0,0,1-2-2.16L116,301.37h5.88l-7.36,108.76A2,2,0,0,1,112.43,412Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.58 308.6 121.34 308.6 121.83 301.37 115.95 301.37 115.58 308.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 297.93,
    width: 298.59,
    height: 3.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 297.93,
    width: 298.59,
    height: 3.44,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.32,
    y: 297.93,
    width: 85.55,
    height: 3.44,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.59,
    y: 294.49,
    width: 313.97,
    height: 3.44,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.63,
    y: 294.49,
    width: 100.93,
    height: 3.44,
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.13,294.64H332.21a1.78,1.78,0,0,1-1.78-1.78h0a1.78,1.78,0,0,1,1.78-1.78h14.92a1.78,1.78,0,0,1,1.78,1.78h0A1.78,1.78,0,0,1,347.13,294.64Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,294.64H332.21a1.78,1.78,0,0,1-1.78-1.78h0a1.78,1.78,0,0,1,1.78-1.78h14.92a1.78,1.78,0,0,1,1.78,1.78h0A1.78,1.78,0,0,1,347.13,294.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,294.64H318.22a1.79,1.79,0,0,1-1.79-1.78h0a1.79,1.79,0,0,1,1.79-1.78h14.91a1.79,1.79,0,0,1,1.79,1.78h0A1.79,1.79,0,0,1,333.13,294.64Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,294.64H318.22a1.79,1.79,0,0,1-1.79-1.78h0a1.79,1.79,0,0,1,1.79-1.78h14.91a1.79,1.79,0,0,1,1.79,1.78h0A1.79,1.79,0,0,1,333.13,294.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12,240.49h-2.87a4,4,0,0,0-4.1,4.49l2.45,28a5,5,0,0,0,4.89,4.5h2.87Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12,240.49h-2.87a4,4,0,0,0-4.1,4.49l2.45,28a5,5,0,0,0,4.89,4.5h2.87Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.39 289.92 303.79 289.92 305.36 272 308.96 272 307.39 289.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.39 289.92 303.79 289.92 305.36 272 308.96 272 307.39 289.92",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,277.49H285.45a5,5,0,0,1-4.89-4.5l-2.45-28a4,4,0,0,1,4.1-4.49H329a5,5,0,0,1,4.89,4.49l2.45,28A4.06,4.06,0,0,1,332.23,277.49Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,277.49H285.45a5,5,0,0,1-4.89-4.5l-2.45-28a4,4,0,0,1,4.1-4.49H329a5,5,0,0,1,4.89,4.49l2.45,28A4.06,4.06,0,0,1,332.23,277.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.15,242.3H282.37a2.42,2.42,0,0,0-2.45,2.68l2.45,28a3,3,0,0,0,2.92,2.69h46.78a2.43,2.43,0,0,0,2.45-2.69l-2.45-28A3,3,0,0,0,329.15,242.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,294.64a9.45,9.45,0,0,1,18.89,0Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,294.64a9.45,9.45,0,0,1,18.89,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6,249.18H292.87a.9.9,0,0,0-.91,1,1.12,1.12,0,0,0,1.09,1h25.73a.9.9,0,0,0,.91-1A1.11,1.11,0,0,0,318.6,249.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.41,253.37H293.24a.9.9,0,0,0-.91,1,1.11,1.11,0,0,0,1.09,1h22.17a.9.9,0,0,0,.91-1A1.12,1.12,0,0,0,315.41,253.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,257.56H293.61a.9.9,0,0,0-.91,1,1.09,1.09,0,0,0,1.08,1h24.37a.89.89,0,0,0,.91-1A1.1,1.1,0,0,0,318,257.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,261.74H294a.9.9,0,0,0-.91,1,1.12,1.12,0,0,0,1.09,1H315a.9.9,0,0,0,.91-1A1.11,1.11,0,0,0,314.78,261.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.6,249.18H292.87a.9.9,0,0,0-.91,1,1.12,1.12,0,0,0,1.09,1h25.73a.9.9,0,0,0,.91-1A1.11,1.11,0,0,0,318.6,249.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.41,253.37H293.24a.9.9,0,0,0-.91,1,1.11,1.11,0,0,0,1.09,1h22.17a.9.9,0,0,0,.91-1A1.12,1.12,0,0,0,315.41,253.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,257.56H293.61a.9.9,0,0,0-.91,1,1.09,1.09,0,0,0,1.08,1h24.37a.89.89,0,0,0,.91-1A1.1,1.1,0,0,0,318,257.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,261.74H294a.9.9,0,0,0-.91,1,1.12,1.12,0,0,0,1.09,1H315a.9.9,0,0,0,.91-1A1.11,1.11,0,0,0,314.78,261.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.84,225.71s-5.92,1.13-5.82-2.48,6.21-1.93,6.21-1.93Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.84,225.71s-5.92,1.13-5.82-2.48,6.21-1.93,6.21-1.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.14,234.35l-2.71,4.26a3.77,3.77,0,0,0,3.38.33Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5,233.76c0,.55.28,1,.64,1s.68-.46.67-1-.27-1-.64-1S365.52,233.21,365.5,233.76Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.69,230.33c.24,7.3.5,10.39-2.81,14.46-5.24,4.32-14,4.83-16.43-2.25-2.17-6.38-2.2-17.22,4.63-20.82a10,10,0,0,1,14.61,8.61Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.44,247.9l-.05-.36a1.34,1.34,0,0,0-1.67-1.09l-3,.81A9.68,9.68,0,0,0,376.44,247.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.48,231.27a.29.29,0,0,1-.26-.1,2.25,2.25,0,0,0-1.87-.84.3.3,0,0,1-.32-.25.28.28,0,0,1,.25-.32,2.76,2.76,0,0,1,2.38,1,.29.29,0,0,1,0,.41h0A.25.25,0,0,1,367.48,231.27Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.17 246.06 377.77 256.89 386.82 255.02 383.92 243.93 376.17 246.06",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.53,235.55,371,236.77a14.16,14.16,0,0,1,.58-8.34l-1.82-2.77.28-1.87s-2.83-4.58-.62-5.94,3.62,1.47,3.62,1.47,1.52-4.52,4.18-3.9,1.3,3.45,1.3,3.45,4.3-3.11,6.33-1.58-.51,3.67-.51,3.67,5.15.12,5.32,2.15-2.1,2.21-2.1,2.21,3.4,1.18,3.34,3-2.71,1.92-2.71,1.92,3.45,2.2,2.71,4.12a2.12,2.12,0,0,1-2.66,1.31s1.79,2.29,1.19,3.53a2.19,2.19,0,0,1-2.11,1.09l-2.94,5.22a4.71,4.71,0,0,0-4.59.9l-5.28-8.68Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.62,233.58a5.62,5.62,0,0,0,.93,4.21c1.14,1.61,3,.89,3.7-.83.66-1.56.85-4.27-.81-5.27A2.54,2.54,0,0,0,371.62,233.58Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.65,253.84l-1.79-5.06a14.55,14.55,0,0,0-13.84,2l5.08,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,251.51a21.22,21.22,0,0,0-12.3.79l2.58,1.54h10.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,287.19l-6.68-3.35a1.51,1.51,0,0,0-1.23,0L343.63,286a1.49,1.49,0,0,0-.95,1.3l-.1,1.78a1.51,1.51,0,0,0,2,1.51l2-.7a14.57,14.57,0,0,0,10.1.3Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,287.58,325,284.19a1.51,1.51,0,0,0-1.23-.05l-5.47,2.21a1.51,1.51,0,0,0-.94,1.32l-.1,1.8a1.51,1.51,0,0,0,2,1.52l2-.7a14.44,14.44,0,0,0,10.1.3Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.31,255.75c-3.27,2.78-11.45,10.94-22.07,30.05H356.67s-1.92,1.56-1.13,5.49c0,0,13.92,4.95,17.7,3.26s16-20.42,21.48-27.09c1.9-2.31,5.17-5.4.45-11.41A2,2,0,0,0,392.31,255.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.15,282.56l-3.26-3.07c-1.18,2-2.4,4.05-3.65,6.31H367l2.06,9a9,9,0,0,0,4.23-.22c1-.45,2.57-2.07,4.45-4.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.69 386.32 377.79 401.34 383.9 400.43 382.43 385.81 374.69 386.32",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.4 395.45 382.43 385.81 374.69 386.32 376.63 395.71 383.4 395.45",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,317.07s3.1,16.28-7.52,16.28-24.77,3.48-24.77,3.48,4.07,3.86,5,53.13l-8.82.38s-14.65-55.61-11.76-61.72c4.07-8.61,25.15-11.55,25.15-11.55Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.87 388.6 384.06 388.3 384.58 393.27 374.52 393.71 373.87 388.6",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.87 388.6 384.06 388.3 384.58 393.27 374.52 393.71 373.87 388.6",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,402.28a2.73,2.73,0,0,1-1.94-.26.56.56,0,0,1-.06-.65.75.75,0,0,1,.43-.41c1-.42,3.4.58,3.51.62a.16.16,0,0,1,.09.15.18.18,0,0,1-.11.14A11.52,11.52,0,0,1,375,402.28Zm-1.17-1.11a1,1,0,0,0-.28.07.44.44,0,0,0-.27.25c-.09.2,0,.28,0,.33.34.38,1.95.19,3.12-.09A7,7,0,0,0,373.87,401.17Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.94,401.87h-.07c-.8-.24-2.49-1.44-2.44-2.17,0-.18.1-.4.51-.5a1.16,1.16,0,0,1,.87.16,4.36,4.36,0,0,1,1.28,2.35.15.15,0,0,1,0,.14A.12.12,0,0,1,376.94,401.87Zm-1.87-2.39H375c-.26.06-.27.17-.28.21,0,.43,1.15,1.39,2,1.77a3.54,3.54,0,0,0-1.09-1.85.75.75,0,0,0-.54-.13Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.5,400.9l7-.83a.56.56,0,0,1,.6.37l1.93,5.5a.93.93,0,0,1-.56,1.2l-.2.05c-2.51.26-4.75.39-7.87.76-3.68.45-2.7.78-7,1.36-2.6.34-3.43-2.56-2.35-2.84,5-1.25,5.33-2.84,7.07-4.88A2.21,2.21,0,0,1,377.5,400.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,330.61H366L362.71,332a103,103,0,0,0,1.89,14l15.61-4.5c-.86-4.05-1.53-4.68-1.53-4.68s1.42-.35,3.69-.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,331.74a14.47,14.47,0,0,0-.33,2.6,90.09,90.09,0,0,1,10.8-1,7,7,0,0,0,.5-9.08l-6.22,2.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.8 390.35 362.56 404.35 368.18 403.22 364.32 388.24 356.8 390.35",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.89 398.24 364.32 388.24 356.8 390.35 360.55 399.45 366.89 398.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,318s3.11,16.28-7.52,16.28-42.51,9.8-42.51,9.8,4.69,1.73,12.83,47.18l-9.21,2.09s-23-49.56-20.13-55.67c4.07-8.6,43.8-19.68,43.8-19.68Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.81 392.75 366.74 390.41 367.87 394.93 357.39 397.35 355.81 392.75",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.81 392.75 366.74 390.41 367.87 394.93 357.39 397.35 355.81 392.75",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.09,405a2.82,2.82,0,0,1-1.93-.26.57.57,0,0,1-.06-.66.75.75,0,0,1,.43-.41c1-.42,3.4.58,3.5.62a.18.18,0,0,1,.1.15.16.16,0,0,1-.11.14A11.44,11.44,0,0,1,359.09,405Zm-1.16-1.12a.89.89,0,0,0-.28.07.4.4,0,0,0-.27.25c-.09.2,0,.28,0,.33.34.38,1.95.2,3.12-.09A7,7,0,0,0,357.93,403.87Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,404.57h-.07c-.8-.24-2.5-1.44-2.45-2.17,0-.18.1-.4.51-.49a1.11,1.11,0,0,1,.87.15,4.33,4.33,0,0,1,1.29,2.35.15.15,0,0,1,0,.14A.12.12,0,0,1,361,404.57Zm-1.87-2.39H359c-.27.06-.27.17-.28.21,0,.44,1.15,1.4,2,1.77a3.53,3.53,0,0,0-1.08-1.85.75.75,0,0,0-.54-.13Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,403.6l6.95-.83a.55.55,0,0,1,.6.37l1.94,5.5a.94.94,0,0,1-.57,1.2l-.19.05c-2.51.26-4.75.39-7.87.77-3.69.44-2.7.77-7,1.35-2.6.35-3.44-2.56-2.35-2.84,5-1.24,5.33-2.84,7.06-4.88A2.26,2.26,0,0,1,361.56,403.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.67,255.16a2.35,2.35,0,0,1,2.4-2.39l20.49.4a14.05,14.05,0,0,1,12,7.22c4.75,8.48,11,25.83,10.85,58.49h-34S365.87,276.49,365.67,255.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.17,263.4c.49,4.91,1.29,10.32,2.26,15.79,5.15-10.79,2.39-19.62,2.39-19.62Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.74,253.68c-2.39,2.79-6.1,8.37-17.34,28.83l-17.19,3.66s-1.92,1.58-1.13,5.56c0,0,18.45,3.17,22.23,1.46s13.43-16.23,17.86-23.74c1.83-3.1,2.8-9.21-2.7-15.75A1.14,1.14,0,0,0,365.74,253.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.59,411.8l-25.21-9.28-25.48,9.29a1.35,1.35,0,0,1-1.81-1.27h0a1.36,1.36,0,0,1,.78-1.22L400.38,397l26.25,12.3a1.35,1.35,0,0,1,.77,1.22h0A1.34,1.34,0,0,1,425.59,411.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.59,411.8l-25.21-9.28-25.48,9.29a1.35,1.35,0,0,1-1.81-1.27h0a1.36,1.36,0,0,1,.78-1.22L400.38,397l26.25,12.3a1.35,1.35,0,0,1,.77,1.22h0A1.34,1.34,0,0,1,425.59,411.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.44 404.69 400.38 402.52 406.05 404.61 406.05 399.68 400.38 397.02 394.44 399.78 394.44 404.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.25,412h0a2.24,2.24,0,0,1-2.23-2l-.71-7.47v-62h5.88v62l-.72,7.47A2.24,2.24,0,0,1,400.25,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.25,412h0a2.24,2.24,0,0,1-2.23-2l-.71-7.47v-62h5.88v62l-.72,7.47A2.24,2.24,0,0,1,400.25,412Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.31,
    y: 340.5,
    width: 5.88,
    height: 7.22,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.14,334.86a91.36,91.36,0,0,0-20.34-2.8c-7.07-.18-33.5,0-39.78,0a92,92,0,0,0-22.7,2.83c-4.66,1.19-3.23,7.91,1,8,.38,0,80.3,0,80.59,0C444.29,343.05,445.9,336.07,441.14,334.86Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.14,334.86a91.36,91.36,0,0,0-20.34-2.8c-7.07-.18-33.5,0-39.78,0a92,92,0,0,0-22.7,2.83c-4.66,1.19-3.23,7.91,1,8,.38,0,80.3,0,80.59,0C444.29,343.05,445.9,336.07,441.14,334.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.48,342.71a83.25,83.25,0,0,1,41.07,0c5.08,1.29,7.25-6.56,2.17-7.85a92.3,92.3,0,0,0-45.4,0c-5.07,1.29-2.92,9.15,2.16,7.85Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.48,342.71a83.25,83.25,0,0,1,41.07,0c5.08,1.29,7.25-6.56,2.17-7.85a92.3,92.3,0,0,0-45.4,0c-5.07,1.29-2.92,9.15,2.16,7.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,276.61a2.5,2.5,0,0,0-2.25,1.3,86.87,86.87,0,0,0-10.87,60,2.21,2.21,0,0,0,2.09,2c1.63.11,30.64,0,31.7,0a2.92,2.92,0,0,0,2.95-3.4,81.08,81.08,0,0,1,10.33-55.79c1.24-2.06-.59-4-2.44-4C450.43,276.59,421.61,276.65,419.76,276.61Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,276.61a2.5,2.5,0,0,0-2.25,1.3,86.87,86.87,0,0,0-10.87,60,2.21,2.21,0,0,0,2.09,2c1.63.11,30.64,0,31.7,0a2.92,2.92,0,0,0,2.95-3.4,81.08,81.08,0,0,1,10.33-55.79c1.24-2.06-.59-4-2.44-4C450.43,276.59,421.61,276.65,419.76,276.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.87,336.43a81.13,81.13,0,0,1,10.33-55.79c1.81-3-2.89-5.73-4.69-2.73a86.87,86.87,0,0,0-10.87,60c.62,3.43,5.85,2,5.23-1.44Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.87,336.43a81.13,81.13,0,0,1,10.33-55.79c1.81-3-2.89-5.73-4.69-2.73a86.87,86.87,0,0,0-10.87,60c.62,3.43,5.85,2,5.23-1.44Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoWeAre);
export default __webpack_public_path__ + "static/media/who_we_are.ef72b6d308ef3249de23a9441d37804b.svg";
export { ForwardRef as ReactComponent };